module.exports = __webpack_public_path__ + "img/news3.ea190539.jpeg";